import { api } from 'modules/axios'
import { onUnmounted } from 'vue'
import { useAxios } from '@vueuse/integrations/useAxios'

export default function useApi() {
  const { execute, abort, data, isFinished, isLoading, isAborted } =
    useAxios(api, { immediate: false })

  async function query(url, params = {}, options = {}) {
    try {
      await execute(url, {
        method: 'GET',
        params,
        ignoreGlobalParams: options.ignoreGlobalParams,
      })
      return data.value
    } catch (error) {
      console.error(error)
    }
  }

  async function mutation(url, method, body = {}, params = {}) {
    try {
      await execute(url, { method, params, data: body })

      return data.value
    } catch (error) {
      console.error(error)
    }
  }

  function abortRequest() {
    if (!isFinished.value) {
      abort()
    }
  }

  onUnmounted(abortRequest)

  return {
    isAborted,
    isLoading,
    isFinished,
    query,
    mutation,
  }
}
